import React from "react";
import PropTypes from "prop-types";
import { FiMapPin } from "react-icons/fi";

import "./ExpandableList.scss";

export default class ExpandableListItem extends React.Component {
  render() {
    return (
      <a
        className="expandable"
        href={`#${this.props.uniqueID}`}
        id={this.props.uniqueID}
      >
        <div className="expandable-container" id={this.props.uniqueID}>
          {/* VISIBLE */}
          <div className="visible">
            <div className="date">{this.props.date}</div>
            <div>
              <div style={{ width: "100%" }}>
                <span>{this.props.name}</span>
              </div>
              <div className="location">
                <FiMapPin style={{ verticalAlign: "text-top" }} />
                &nbsp;<span>{this.props.location}</span>
              </div>
            </div>
            <div className="image">
              <img
                src="https://via.placeholder.com/150.png?text=Test"
                alt="company logo"
              />
            </div>
          </div>

          {/* HIDDEN */}
          {this.props.expanded && (
            <div className="expanded">
              <div className="barcode-container">
                <div className="title">
                  Code works at
                  <br />
                  <b style={{ textTransform: "uppercase" }}>
                    {this.props.location} locker
                  </b>
                </div>
                <div className="barcode">
                  <img
                    src={require("../../assets/demo/sample-barcode.png")}
                    alt="sample barcode"
                  />
                  {this.props.unlockID}
                </div>
              </div>
            </div>
          )}
        </div>
      </a>
    );
  }
}

ExpandableListItem.propTypes = {
  expanded: PropTypes.bool,
  date: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
  unlockID: PropTypes.string,
  uniqueID: PropTypes.string.isRequired
};
